module.exports = __webpack_public_path__ + "img/pro_05.350cfb2e.jpg";